export const themeTypography = {
    fontFamily: "'Inter', 'DM Sans', sans-serif",
    h1: {
      fontWeight: "300",
      fontSize: "96px",
      lineHeight: "112px",
      letterSpacing: "-1.5px",
    },
    h2: {
      fontWeight: "300",
      fontSize: "60px",
      lineHeight: "72px",
      letterSpacing: "-0.5px",
    },
    h3: {
      fontWeight: "400",
      fontSize: "48px",
      lineHeight: "56px",
    },
    h4: {
      fontWeight: "400",
      fontSize: "34px",
      lineHeight: "42px",
      letterSpacing: "0.25px",
    },
    h5: {
      fontWeight: "600",
      fontSize: "24px",
      lineHeight: "32px",
    },
    h6: {
      fontFamily: "'Inter', sans-serif",
      fontWeight: "500",
      fontSize: "20px",
      lineHeight: "23px",
      letterSpacing: "-5%",
    },
    body1: {
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "23px",
      letterSpacing: "-5%",
    },
    body2: {
      fontFamily: "'Inter', sans-serif",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "16.94px",
      letterSpacing: "-5%",
    },
    body3: {
      fontFamily: "'Inter', sans-serif",
      fontSize: "10px",
      fontWeight: "500",
      lineHeight: "16px",
      letterSpacing: "-5%",
    },
    bottomheadernav: {
      fontFamily: "'Inter', sans-serif",
      fontSize: "10px",
      fontWeight: "500",
      lineHeight: "12.1px",
      letterSpacing: "5.5%",
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "28px",
      letterSpacing: "0.15px",
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      letterSpacing: "0.1px",
    },
    overline: {
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "32px",
      letterSpacing: "1px",
    },
    caption: {
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "14.52px",
      letterSpacing: "0.4px",
    },
    closebutton: {
      fontFamily: "'DM Sans', sans-serif",
      fontSize: "19px",
      fontWeight: "500",
      lineHeight: "24.74px",
      // letterSpacing: "0.4px",
    },
    formlink: {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "18px",
      letterSpacing: "0.15px",
    },
    listitem: {
      fontSize: "10px",
      fontWeight: "500",
      lineHeight: "14.52px",
      letterSpacing: "-1%",
    },
  };
  